import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { FormControlLabel, Typography, Divider, CircularProgress } from '@mui/material';
import HeightBox from '../../components/HeightBox';
import { createJobOrder } from './services';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import { getJobOrdersAction } from './actions'
import { useSelector,useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import FormGenerator from './FormGenerator'
const theme = createTheme({
  typography: {
    fontSize: 10, // Adjust the default font size
  },
  components: {
    // Customize the component sizes
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the button font size
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the text field font size
          height: 30, // Adjust the text field height
          size: "small", // Adjust the text field height
          boxSizing: "inherit", // Adjust the text field height
        },
      },
    },
    // Add other components here with their desired customizations
  },
});


export const fieldData = [
  {
    "type": "Select",
    "name": "jobOrderStatus",
    "label": "Job Order Status",
    "options": [
        {'label':'Draft','value':'Draft'},
        {'label':'On Going','value':'On Going'},
        {'label':'Completed','value':'Completed'},
        {'label':'Hold On','value':'Hold On'}
    ],
    "size": "small",
    "required": false,
    "fullWidth": true
  },
    {
      "type": "TextField",
      "name": "nameOfForeignPrincipal",
      "label": "Name of Foreign Principal",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "country",
      "label": "Country",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "address",
      "label": "Foreign Principal Address",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "SLBFEApprovalNumber",
      "label": "SLBFE Approval Number",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "phone",
      "label": "Phone",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "email",
      "label": "Email",
      "size": "small",
      "required": true,
      "fullWidth": true
    },

    {
      "type": "Checkbox",
      "name": "commission",
      "label": "Commission"
    },
    {
      "type": "TextField",
      "name": "commissionToClient",
      "label": "Commission to Client",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "commissionFromClient",
      "label": "Commission from Client",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "workingHours",
      "label": "Working Hours",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "weeklyWorkingHours",
      "label": "Weekly Working Hours",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "availabilityPeriod",
      "label": "Contract Period",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "currency",
      "label": "Currency",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
      "type": "Checkbox",
      "name": "food",
      "label": "Food"
    },
    {
      "type": "Checkbox",
      "name": "accommodation",
      "label": "Accommodation"
    },
    {
      "type": "Checkbox",
      "name": "medical",
      "label": "Medical"
    },
    {
      "type": "Checkbox",
      "name": "transport",
      "label": "Transport"
    },
    {
      "type": "Checkbox",
      "name": "joiningAirTicket",
      "label": "Joining Air Ticket"
    },
    {
      "type": "Checkbox",
      "name": "returnAirTicket",
      "label": "Return Air Ticket"
    }
  ]

const JobOrderForm = (props) => {

     // Define the initial state for working days
const initialWorkingDays = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  };
    const [workingDays, setWorkingDays] = useState(initialWorkingDays);
    // Create an array with the selected working days
  const workingDaysArray = Object.keys(workingDays).filter(
    (day) => workingDays[day]
  );

  const [loading, setLoading] = useState(false);

  const [jobOrder, setJobOrder] = useState({
    profession: '',
    quantity: '',
    accommodation: false,
    transportation: false,
    medical: false,
    airTicketsJoining: false,
    airTicketsAnnual: false,
    contractPeriod: '',
    probationPeriod: '',
    annualLeave: '',
    medicalLeave: '',
    emergencyLeave: '',
    overtime: false,
    workingHours: '',
    weeklyWorkingHours: '',
    workingDays: '',
    agencyFee: '',
    jobDescription: '',
    workSite: '',
    availabilityPeriod: '',
    nameOfForeignPrincipal: '',
  });

  const dispatch=useDispatch();
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === 'checkbox' ? checked : value;

    setJobOrder((prevState) => ({
      ...prevState,
      [name]: fieldValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Perform form submission logic or API request with jobOrder data
    console.log(jobOrder);
    const jobOrderData = {
      ...jobOrder,
      professions:rows
    };
    createJobOrder(jobOrderData).then((response) => {
      console.log(response);
      setLoading(false);
      dispatch(getJobOrdersAction);
      props.handleClose()
    }).catch((error) => {
      console.log(error);
      setLoading(false);
      props.handleClose()
    });
  };

  const handleOnClose = () => {
    props.handleClose()
  };


 
 React.useEffect(() => {
    setJobOrder((prevState) => ({
        ...prevState,
        workingDays: workingDays,
        }));
  }, [workingDays]);

  
  
    const [rows, setRows] = useState([
      {
        serialNumber: '',
        jobCategory: '',
        vacancies: '',
        salary: '',
        currency: '',
        fee:'',
      },
    ]);
  
    const handleChangeRows = (index, field, value) => {
      const updatedRows = [...rows];
      updatedRows[index][field] = value;
      setRows(updatedRows);
    };
  
    const addRow = () => {
      setRows([...rows, { serialNumber: '', jobCategory: '', vacancies: '', salary: '', currency: '',fee:'' }]);
    };
  
    const removeRow = (index) => {
      const updatedRows = [...rows];
      updatedRows.splice(index, 1);
      setRows(updatedRows);
    };

  const [formFields, setFormFields] = useState([])

  

  return (
  <ThemeProvider theme={theme}>
    <form onSubmit={handleSubmit}>
    <Grid container spacing={3}>
      
        <Grid item xs={12}>

              <FormGenerator formData={jobOrder} handleChange={handleChange} fields={fieldData} />

    </Grid>
       <Grid item xs={12}>
       <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Se/No</TableCell>
            <TableCell>Job Category</TableCell>
            <TableCell>No of Vacancies</TableCell>
            <TableCell>Salary </TableCell>
            <TableCell>currency </TableCell>
            <TableCell> SLBFE Chargeable Amount </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  size='small'
                  value={row.serialNumber}
                  onChange={(e) => handleChangeRows(index, 'serialNumber', e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  size='small'
                  value={row.jobCategory}
                  onChange={(e) => handleChangeRows(index, 'jobCategory', e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                                  size='small'

                  value={row.vacancies}
                  onChange={(e) => handleChangeRows(index, 'vacancies', e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                 size='small'
                  value={row.salary}
                  onChange={(e) => handleChangeRows(index, 'salary', e.target.value)}
                />
               
              </TableCell>
              <TableCell>
              <TextField
                  size='small'

                  value={jobOrder?.currency}
                  onChange={(e) => handleChangeRows(index, 'currency', e.target.value)}
                />
              </TableCell>
              <TableCell>
              <TextField
                  size='small'

                  value={row.fee}
                  onChange={(e) => handleChangeRows(index, 'fee', e.target.value)}
                />
              </TableCell>
              <TableCell>
                <IconButton onClick={() => removeRow(index)}>
                  <RemoveIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <IconButton onClick={addRow}>
        <AddIcon />
      </IconButton>
    </div>
        </Grid>
        <Grid item xs={12}>
        <Button
          disabled={loading}
          type="submit" variant="contained" color="primary">
            {loading ? <CircularProgress size={24} /> : 'Submit'}
        </Button>
        <Button onClick={handleOnClose} variant="contained" color="secondary">Close</Button>
        </Grid>
    </Grid>
    </form>
  </ThemeProvider>
  );
};

export default JobOrderForm;
